import { Opaque } from "../../../../Helpers/TypingUtils";
import { CallInitSectionLightboxProps } from "../../../../Forms/PublicForm/InitSectionLightbox";
import { IErrorLogTaskInfo } from "../../ErrorManager/Utils/Models";
import { rsvPreferredTransfers } from "../../ModalManager/Modals/UploadXmlInTable/UploadXmlInTable";
import { FormSavingStatus } from "../../../../Controls/FormParts/Panel/FormSaveStatus/Store/FormSaveStatusActions";

import { ExternalEvent, ExternalEventPath } from "./ExternalEvent";
import { ErrorEventInfo, ExternalEventInfo } from "./ExternalEventInfo";

function createCandyEvent(event: [ExternalEventPath, ExternalEventInfo]): ExternalEvent {
    return event as Opaque<ExternalEvent, "CandyExternalEvent">;
}

export function getExternalEventInfo(event: ExternalEvent): ExternalEventInfo {
    return event[1];
}

export function getExternalEventPath(event: ExternalEvent): ExternalEventPath {
    return event[0];
}

export function formSendEvent(): ExternalEvent {
    return createCandyEvent([["form", "send"], undefined]);
}

export function formCloseEvent(): ExternalEvent {
    return createCandyEvent([["form", "close"], undefined]);
}

function formSaveEventPath(): ExternalEventPath {
    return ["form", "save"];
}

export function formSaveEvent(): ExternalEvent {
    return createCandyEvent([formSaveEventPath(), undefined]);
}

export function formShowFeedbackEvent(): ExternalEvent {
    return createCandyEvent([["form", "showFeedback"], undefined]);
}

export function formPrintEvent(): ExternalEvent {
    return createCandyEvent([["form", "print"], undefined]);
}

export function formSavingStatusEvent(status: FormSavingStatus): ExternalEvent {
    return createCandyEvent([["form", "changeSavingStatus"], status]);
}

export function formShowTourEventPath(): ExternalEventPath {
    return ["form", "showTour"];
}

export function formShowTourEvent(): ExternalEvent {
    return createCandyEvent([formShowTourEventPath(), undefined]);
}

export function formInterdocumentTransferEvent(): ExternalEvent {
    return createCandyEvent([["form", "interdocumentTransfer"], undefined]);
}

export function formDidMountEventPath(): ExternalEventPath {
    return ["form", "root", "didmount"];
}

export function formDidMountEvent(): ExternalEvent {
    return createCandyEvent([["form", "root", "didmount"], undefined]);
}

export function formUpdateNavigationInstanceEventPath(): ExternalEventPath {
    return ["form", "navigation", "updateInstance"];
}

export function formUpdateNavigationInstanceEvent(currentInstance: string | null | undefined): ExternalEvent {
    return createCandyEvent([["form", "navigation", "updateInstance"], currentInstance ?? undefined]);
}

export function formTourStepsShownEvent(shownIds: string[]): ExternalEvent {
    return createCandyEvent([["form", "tourStepsShown"], shownIds]);
}

export function formCallInitSection(options: CallInitSectionLightboxProps): ExternalEvent {
    return createCandyEvent([["form", "callInitSection"], options]);
}
export function formPreferredInterdocumentTransferEvent(options: rsvPreferredTransfers): ExternalEvent {
    return createCandyEvent([["form", "preferredInterdocumentTransfer"], options]);
}

/**
    Выпилить в рамках https://yt.skbkontur.ru/issue/FS-7999/Pereehat-na-generaciyu-kontenta-futera-v-SimpleForm-iz-resursov
 */
export function formSendToClientForSign(): ExternalEvent {
    return createCandyEvent([["form", "sendToClientForSign"], undefined]);
}

/** У нас 2 сервиса сотрудников. 1 занимается команда СС, мы все их знаем.
    Второй, старенький - на поддержке у keapi, встроен в кевеб. Этот event - про второй.
*/
export function formOpenEmployeeEditor(employeeId: string): ExternalEvent {
    return createCandyEvent([["form", "openEmployeeEditor"], employeeId]);
}

export function formPageChangedEventPath(pageId: string): ExternalEventPath {
    return ["form", "pageChanged", pageId];
}

export function formPageChangedEvent(pageId: string): ExternalEvent {
    return createCandyEvent([["form", "pageChanged", pageId], undefined]);
}

export function formComponentDidMountEventPath(controlId: string): ExternalEventPath {
    return ["form", controlId, "didmount"];
}

export function formComponentDidMountEvent(controlId: string): ExternalEvent {
    return createCandyEvent([["form", controlId, "didmount"], undefined]);
}

export function formDataProviderErrorEvent(errorInfo: ErrorEventInfo): ExternalEvent {
    return createCandyEvent([["form", "error", "dataProvider"], errorInfo]);
}

// -------- Временный код, пока Стас выносит сервис проверок из кевеба в отдельного демона ----//
// Тут мы вызываем этот общий сервис из кевеба
export const EXTERN_CHECK_TASK_EVENT_PATH = ["form", "startExternCheckTask"];
export function formStartExternCheckTask(taskSetter: (taskId: string) => void): ExternalEvent {
    // @ts-ignore - временно, пока ходим в кевеб за протоколом
    return createCandyEvent([EXTERN_CHECK_TASK_EVENT_PATH, taskSetter]);
}

export function formGetExternCheckTask(params: {
    taskId: string;
    setTaskStatus: (taskInfo: IErrorLogTaskInfo) => void;
}): ExternalEvent {
    // @ts-ignore - временно, пока ходим в кевеб за протоколом отдаём им колбек, куда они его засетят
    return createCandyEvent([["form", "getExternCheckTask"], params]);
}
//----------------------------------------------------------------------------------------
